<template>
  <div class="pic_bg">
    <header>
      <!-- <el-image :src="iconHeader"></el-image> -->
      <span class="title_font">{{ titleName }}</span>
    </header>
    <body>
      <template v-if="isVideo">
          <div id="J_prismPlayer"></div>
      </template>
      <template v-else-if="isZJTD">
        <div style="margin:30px 0;min-height:100px;width:100%;">
          <div style="float:left">
            <el-image :src="zjtdObj.etPhoto" style="width:200px;">
            </el-image>
          </div>
          <div style="float:left;width:calc(100% - 300px);margin-left:20px;">
            <div style="font-size:18px;line-height:30px;">{{zjtdObj.etName}}</div>
            <div style="font-size:18px;line-height:30px;">{{zjtdObj.etGoodat}}</div>
            <div class="ql-editor" v-html="zjtdObj.etDesc" style="margin-top:20px;"></div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="ql-editor" v-html="innerhtml"></div>
      </template>
    </body>
  </div>
</template>

<script>
import { getVideoAddress } from "@/network/api";
export default {
  data() {
    return {
      titleName: '',
      iconHeader: require("@/assets/images/pageico_4.png"),
      innerhtml: '',
      isVideo: false,
      flashPlayer: null,
      isZJTD: false,
      zjtdObj: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const data = this.$route.params;
      if (JSON.stringify(data) == '{}') {
        this.$router.push({
          name: 'HelloWorld'
        })
        return
      }
      if (data.isVideo) {
        this.isVideo = true;
        this.titleName = data.htmlTitle;
        getVideoAddress(data.videoId).then((info) => {
          if (info.code == 200) {
            var player = new Aliplayer(
              {
                id: "J_prismPlayer",
                source: info.data[0],
              },
              function (player) {
                console.log("The player is created.");
              }
            );
            this.flashPlayer = player;
          } else {
            this.$message.error(info.msg);
          }
        });
      } else if (data.isZJTD) {
        this.isZJTD = true;
        this.zjtdObj = data.obj
      } else {
        this.titleName = data.htmlTitle;
        this.innerhtml = data.htmlInfo;
      }
    }
  }
}
</script>

<style scoped>
.pic_bg {
  width: 1150px;
  margin: 0 auto;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 50px;
  min-height: 100px;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.btn-h:hover {
  cursor: pointer;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/InformationDetail.vue